module.exports = {
      id: "stories-usage",
      viewBox: "0 0 33 27.835",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#stories",
      toString: function () {
        return this.url;
      }
    }